module.exports = __webpack_public_path__ + "static/media/gh8.3943260d.png";